import config from '@/config'
import store from '@/store'

import { googleLogin as googleLoginAPI } from '@/api/user'
import { REQUEST_SUCCESS_CODE } from '@/config/constant'
import { $notification, $t, $loading } from '@/utils'
import { redirectByLogin } from './user'

const defaultErrorText = $t('login.googleLoginError')

// Google OAuth2 登录跳转
export const googleLogin = (redirectType: string) => {
    // 检查Google Client ID配置
    if (!config.googleClientId) {
        $notification.error($t('login.googleLoginError'))
        return
    }

    let redirectUrl = window.location.protocol + '//' + window.location.host

    if (redirectType) {
        localStorage.setItem('google_redirect_type', redirectType)
    }

    // Google授权登录页
    const targetUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${config.googleClientId}&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile&response_type=token&redirect_uri=${redirectUrl}`

    const isEmbedded = typeof window !== 'undefined' && window !== window.top;
    if (isEmbedded && redirectType !== 'standalone') {
        const width = 500;
        const height = 650;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;
        window.open(
            '/login-standalone?source=google_popup',
            'SoviLoginPopup',
            'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top + ',scrollbars=yes'
        );
        return;
    }

    window.location.href = targetUrl
}

// 处理Google OAuth2回调
export const checkGoogleLoginCallback = async () => {
    if (isGoogleCallback()) {
        $loading.loading()

        try {
            const res = await handleGoogleCallback()

            if (res.code === REQUEST_SUCCESS_CODE) {
                await store.dispatch('user/googleLogin', {
                    googleUserInfo: res.data,
                    accessToken: res.accessToken
                })

                if (typeof window !== 'undefined' && (window.name === 'SoviLoginPopup' || window.opener)) {
                    clearOAuthParams();
                    window.close();
                    return true;
                }

                const redirectType = localStorage.getItem('google_redirect_type')
                redirectByLogin(redirectType || undefined)
                localStorage.removeItem('google_redirect_type')

                console.log('Google login success', res)
                clearOAuthParams()
            }

            $loading.hide()

            return true
        } catch (error: any) {
            try {
                const errorData = JSON.parse(error.message)

                if (errorData.status != 'cancel') {
                    $notification.error(defaultErrorText, errorData.error)
                }
            } catch (error: any) {
                $notification.error(defaultErrorText)
            }

            console.error(defaultErrorText, error)
            clearOAuthParams()

            $loading.hide()

            return false
        }
    }
}

// 处理Google OAuth2回调
export const handleGoogleCallback = async () => {
    try {
        const hash = window.location.hash
        const params = new URLSearchParams(hash.substring(1))
        const accessToken = params.get('access_token')
        const error = params.get('error')

        if (error) {
            if (error === 'access_denied') {
                throw new Error(JSON.stringify({ status: 'cancel' }))
            } else {
                throw new Error(JSON.stringify({ status: 'error', error: defaultErrorText + ': ' + params.get('error_description') }))
            }
        }

        if (!accessToken) {
            throw new Error(JSON.stringify({ status: 'error', error: defaultErrorText + ': No access token' }))
        }

        // 使用access_token获取Google用户信息
        const googleUserInfo = await fetchGoogleUserInfo(accessToken)

        // 调用后端Google登录API
        // const loginResult = await googleLoginAPI({
        //     email: googleUserInfo.email,
        //     name: googleUserInfo.name,
        //     avatar: googleUserInfo.picture,
        //     googleId: googleUserInfo.id,
        //     accessToken: accessToken
        // })

        // if (loginResult.code === REQUEST_SUCCESS_CODE) {
        return {
            code: REQUEST_SUCCESS_CODE,
            data: googleUserInfo,
            // ext: loginResult.data,
            accessToken: accessToken // 保留accessToken
        }
        // } else {
        //     throw new Error(JSON.stringify({ status: 'error', error: defaultErrorText + ': ' + loginResult.msg }))
        // }
    } catch (error) {
        throw error
    }
}

// 获取Google用户信息
const fetchGoogleUserInfo = async (accessToken: string) => {
    try {
        const response = await fetch(`https://www.googleapis.com/oauth2/v2/userinfo?access_token=${accessToken}`)

        if (!response.ok) {
            let errorText = (await response.text()) || '{}'
            let errorData = JSON.parse(errorText)

            // ts-ignore
            throw new Error(JSON.stringify({ status: 'error', error: defaultErrorText + ': ' + (response.status ? response.status + ', ' : '') + errorData.error?.message }))
        }

        const userInfo = await response.json()

        // 验证必要字段
        if (!userInfo.email || !userInfo.id) {
            throw new Error(JSON.stringify({ status: 'error', error: defaultErrorText + ': Google get user info error no email or id' }))
        }

        return userInfo
    } catch (error) {
        throw error
    }
}

// 检查是否是Google登录回调
export const isGoogleCallback = () => {
    const hash = window.location.hash

    return hash.includes('access_token=') || hash.includes('error=')
}

// 清理URL中的OAuth参数
export const clearOAuthParams = () => {
    if (window.location.hash) {
        window.history.replaceState({}, document.title, window.location.pathname + window.location.search)
    }
}
